<pda-base>
    <div class="pda-classes full-height">
        <div class="pda-classes-section">
            <div class="pda-classes-section-title-container">
                <h2 class="pda-title">
                    <span class="pda-title-1 text-shadow">Nuestros</span>
                    <span class="pda-title-2 text-shadow">&nbsp;Cursos</span>
                </h2>
            </div>
            <div class="pda-classes-section-gallery">
                <pda-gallery [config]="config"></pda-gallery>
            </div>
        </div>
    </div>
</pda-base>